import * as _ from 'lodash-es';
import moment from 'moment';
import { Component, Filter, Vue } from 'types-vue';

@Component
export class DatesMixin extends Vue {

  protected getLocalDate(date: Date | number | string = new Date()): moment.Moment {
    // El backend envía fechas naive en hora española (sin timezone, ej. 2026-10-14T16:54:15).
    // moment() ya las interpreta como hora local, por lo que NO hay que sumar ningún offset.
    return moment(date)
  }
}
